const fragmentPriceRangeFields = `
  fragment PriceRangeFields on PriceRange {
    maximum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
    minimum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
  }
`;

export default `
  query getProductPriceBySku(
    $filter: ProductAttributeFilterInput,
    $configurations: [ID!]
  ) {
    products(filter: $filter) {
      items {
        price_range {
          ...PriceRangeFields
        }

        ... on ConfigurableProduct {
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }

          configurable_product_options_selection(configurableOptionValueUids: $configurations) {
            options_available_for_selection {
              attribute_code
              option_value_uids
            }
            media_gallery {
              url
              position
              disabled
              label
              ... on ProductVideo {
                video_content {
                  media_type
                  video_description
                  video_metadata
                  video_provider
                  video_title
                  video_url
                }
              }
            }
            product3d {
              product3d_image {
                  disabled
                  label
                  position
                  url
              }
              product3d_model
            }
            variant {
              uid
              sku
              name
              made_in_canada
              att_quick_ship
              order_time_frame
              b_collection_name
              new
              best_seller
              further_reduced
              assembly
              assembled_length
              assembled_width
              assembled_height
              included
              att_shipping_dimensions
              att_additional_dimensions
              warranty_note
              material
              country_of_manufacture
              att_weight_capacity
              att_climbing_details
              att_split_details
              description {
                html
              }
              price_tiers {
                quantity
                final_price {
                  value
                }
                discount {
                  percent_off
                  amount_off
                }
              }

              price_range {
                ...PriceRangeFields
              }
            }
          }
        }

        ... on BundleProduct {
          items {
            position
            required
            sku
            title
            type
            uid
            options {
              can_change_quantity
              is_default
              position
              uid
              quantity
              product {
                uid
                sku
                name
                price_range {
                   ...PriceRangeFields
                }
              }
            }
          }
        }

        ... on GroupedProduct {
          items {
            position
            qty
            product {
              uid
              sku
              name
              stock_status
              only_x_left_in_stock
              price_range {
                maximum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
                minimum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
              }
              thumbnail {
                url
                position
                disabled
                label
              }
            }
          }
        }

      }
    }
  }
  ${fragmentPriceRangeFields}
`;
